export const FACEBOOK = "Facebook";
export const INSTAGRAM = "Instagram";
export const OTHER = "Other";
export const PINTEREST = "Pinterest";
export const SNAPCHAT = "Snapchat";
export const TIKTOK = "Tiktok";
export const TWITCH = "Twitch";
export const X = "X";
export const YOUTUBE = "Youtube";
